var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-6" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "pt-2 px-2 border border-gray-200",
          staticStyle: { height: "55vh" },
        },
        [_c("group-list-wrapper", { attrs: { indexUrl: _vm.indexUrl } })],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-6" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "pt-2 px-2 border border-gray-200",
          staticStyle: { height: "55vh" },
        },
        [_c("permission-list-wrapper")],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pt-2 pb-2 bg-gray-500 text-center" }, [
      _c("h6", { staticClass: "m-0" }, [_vm._v("GROUPS")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pt-2 pb-2 bg-gray-500 text-center" }, [
      _c("h6", { staticClass: "m-0" }, [_vm._v("USER PERMISSIONS")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }